<div class="sh-filter-bar">
    <sh-generic-filter-item
        *ngFor="let filter of filters$ | async"
        [filter]="filter"
        [i18n]="i18n"
        (filterChanged)="onFilterChange($event)"
        (removeFilter)="onRemoveFilter(filter)"
    ></sh-generic-filter-item>
</div>
